import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "../modules/app/mainReducer";
import type { Carga } from "../modules/carga/types";
import { agruparItensPorEntrega, encontrarEntregaPorNota } from "../modules/carga/utils/agruparEntregas";
import type { Entrega } from "../modules/carga/utils/agruparEntregas";

export type EntregaDaRota = {
  j14_ukey?: string;
  j10_ukey?: string;
  carga?: Carga;
  entrega?: Entrega;
};

export default function useEntregaDaRota(): EntregaDaRota {
  const { ukey: j14_ukey, j10_ukey } = useParams();

  const carga = useSelector((state: RootState) => {
    const atual = state.carga.carga;
    if (atual && atual.j14_ukey === j14_ukey) return atual;
    return state.carga.cargas?.find((i) => i.j14_ukey === j14_ukey) || atual;
  });

  const entrega = useMemo(
    () => (carga?.itens ? encontrarEntregaPorNota(agruparItensPorEntrega(carga.itens), j10_ukey) : undefined),
    [carga?.itens, j10_ukey]
  );

  return { j14_ukey, j10_ukey, carga, entrega };
}
